import { Component, Inject } from '@angular/core';
import { AssetDropdownService } from '../assets/assets-dropdown.service';
import { cdkOverlayRef } from '../custom-overlay/cdk-overlay-ref';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { forkJoin, Subject } from 'rxjs';
import { LogSearchService } from 'src/app/log-search/services/log-search.service';
import { AdvanceFilterComponent } from 'src/app/alerts/template/advance-filter/advance-filter.component';
import { CdkOverlyayService } from '../custom-overlay/cdk-overlyay.service';
import { TimePanelComponent } from 'src/app/log-search/time-panel/time-panel.component';
import { OverlayService } from 'src/app/log-search/services/overlay.service';
import { takeUntil } from 'rxjs/operators';
import { SharedService } from 'src/app/services/shared.service';
import { FILE_PREVIEW_DIALOG_DATA } from '../custom-overlay/cdk-overlay-injector';


@Component({
  selector: 'app-search-suggestion',
  templateUrl: './search-suggestion.component.html',
  styleUrls: ['./search-suggestion.component.scss']
})
export class SearchSuggestionComponent {
  //to hold the dropdowns metadata
  assetsMetaData = this.assetsService.loadmetaData().common_top_bar;
  assetslabels = this.assetsService.loadlabels();
  platformdata = this.assetsService.loadplatformdata();
  $destroy: Subject<boolean> = new Subject();

  platformList = JSON.parse(JSON.stringify(this.platformdata))
  // relative_time_options:any=[]
  relative_times: any = []
  show_relative_times: any = []
  selectedPlatform: string = ''
  selectedfield: string = ''
  platformfields: any = []
  lexiconValue: any = []
  sourceErrorState: boolean = false
  sourceErrorMsg: string = ''
  selectedfieldCount: number = 0
  selectedPlatformValue: string = ''

  suggestionSpinnerState: boolean = true
  suggestionplatformSpinnerState: boolean = true
  suggestionsourceSpinnerState: boolean = true
  suggestionfieldSpinnerState: boolean = true
  suggestionvalueSpinnerState: boolean = true
  selectedTimeRange = 'Last 7 Days'
  selectedTimeStructure = {
    "disp": "Last 7 Days",
    "value": [
      "-",
      "day",
      6,
      0
    ]
  }

  suggestion_chips = []
  internalOverlayRef;
  timeRange = new FormControl('')




  assetsData: any;

  selectedHost: any = []
  fieldsList: any = []

  fieldsValue: any = []

  switchLabelText: string = 'Source'




  constructor(

    public assetsService: AssetDropdownService,
    private overLayRef: cdkOverlayRef,
    private cdkoverlayDialog: CdkOverlyayService,
    private dropdown: OverlayService,
    private sharedService: SharedService,
    private logSearchService: LogSearchService,
    @Inject(FILE_PREVIEW_DIALOG_DATA) public data: any

  ) { }

  // timerange:FormControl = new FormControl([ "-1","hour",24])
  // toggle
  platformSearch
  sourceSearch
  fieldsSearch
  valueSearch
  sourceSelectAll

  ngOnInit() {
    // this.toggle = new FormControl(false);
    this.sourceSelectAll = new FormControl(false)
    this.platformSearch = new FormControl('')
    this.sourceSearch = new FormControl('')
    this.fieldsSearch = new FormControl('')
    this.valueSearch = new FormControl('')

    this.buildDefaultRequest()

    // console.log("this.logSearchService.relative_times=========",this.logSearchService.relative_times)
    // this.timerange.patchValue()
    // this.relative_time_options = this.sharedService.metaData.logsearch.common_top_bar.search_bar.time_panel.relative_time_options
    // console.log("this.relative_time_options=[======",this.relative_time_options)
    this.relative_times = this.logSearchService.relative_times
    this.fetchSelectedTimeRange(this.relative_times, this.selectedTimeRange, this.selectedTimeStructure)
    // this.show_relative_times = this.relative_times.slice(0,3)
    //  this.relative_times=[{
    //   "disp": "Last 24 Hours",
    //   "value": [
    //     "-",
    //     "hour",
    //     24,
    //     0
    //   ]
    // },{
    //   "disp": "Last 7 Days",
    //   "value": [
    //     "-",
    //     "day",
    //     6,
    //     0
    //   ]
    // },
    // {
    //   "disp": "Last 10 Days",
    //   "value": [
    //     "-",
    //     "day",
    //     9,
    //     0
    //   ]

    // },
    // {
    //   "disp": "Last 30 Days",
    //   "value": [
    //     "-",
    //     "day",
    //     29,
    //     0
    //   ]

    // }
    // ]

    this.platformSearch.valueChanges.subscribe((platformSearchVal: string) => {
      if (platformSearchVal != '') {
        this.platformList = [...this.platformdata.filter((item: any) => {
          return item['disp'].toLowerCase().includes(platformSearchVal.toLowerCase())
        })]
      }
      else {
        this.platformList = JSON.parse(JSON.stringify(this.platformdata))
      }
    })


    this.sourceSearch.valueChanges.subscribe((sourceSearchVal: string) => {
      if (sourceSearchVal != '') {
        this.selectedHost = [...this.assetsData[0].hosts.filter((item: any) => {
          return item['disp'].toLowerCase().includes(sourceSearchVal.toLowerCase())
        })]
        if (this.selectedHost.length == 0) {
          this.sourceSelectAll.setValue(false, { emitEvent: false })
        }

      }
      else {
        this.selectedHost = JSON.parse(JSON.stringify(this.assetsData[0].hosts))

      }
      this.toggleActionSourceSelectall(false, sourceSearchVal, 'search')
    })


    this.fieldsSearch.valueChanges.subscribe((fieldsSearchVal: string) => {
      if (fieldsSearchVal != '') {
        this.fieldsList = [...this.platformfields.filter((item: any) => {
          return item['disp'].toLowerCase().includes(fieldsSearchVal.toLowerCase())
        })]
      }
      else {
        this.fieldsList = JSON.parse(JSON.stringify(this.platformfields))
      }
    })


    this.valueSearch.valueChanges.subscribe((valueSearchVal: string) => {
      if (valueSearchVal != '') {
        this.fieldsValue = [...this.lexiconValue.filter((item: string) => {
          return item.toLowerCase().includes(valueSearchVal.toLowerCase())
        })]
      }
      else {
        this.fieldsValue = JSON.parse(JSON.stringify(this.lexiconValue))
      }
    })

    this.sourceSelectAll.valueChanges.subscribe((selected: boolean) => {
      // console.log("this.sourceSelectAll.valueChanges=======",selected)
      this.toggleActionSourceSelectall(selected, '', 'valueChange')
    })



    this.dropdown.time$.pipe(takeUntil(this.$destroy))
      .subscribe((data: any) => {

        // let selectedTimeObj = [data]

        // this.relative_times.forEach((item:any)=>{
        //   if(item.disp != data.disp){
        //   selectedTimeObj.push(item)

        //   }
        // })
        // this.show_relative_times = selectedTimeObj.slice(0,3)
        this.fetchSelectedTimeRange(this.relative_times, data.disp, data)
        this.selectedTimeRange = data.disp
        this.selectedTimeStructure = data
      })
  }


  fetchSelectedTimeRange(relativetimes: any, seletedTime: string, timestruct: any) {
    this.show_relative_times.length = 0
    if (seletedTime.startsWith("Between") || seletedTime.startsWith("Since") || seletedTime.startsWith("Before")) {
      this.show_relative_times.push(timestruct)
    } else {
      relativetimes.forEach((item: any) => {
        if (item.disp == seletedTime) {
          this.show_relative_times.push(item)
        }
      })
    }

    relativetimes.forEach((item: any) => {
      if (this.show_relative_times.length < 3 && item.disp != seletedTime && (item.disp == "Last 7 Days" || item.disp == "Last 10 Days" || item.disp == "Last 30 Days")) {
        this.show_relative_times.push(item)
      }
    })

  }

  formCancel() {
    // if (!this.assetsService.assetsSpinnerState) {
    this.overLayRef.close()
    // }
  }

  formSubmit() {
    let hostlist = [];
    this.selectedHost.forEach((item: any) => {
      if (item["isSelected"]) {
        hostlist.push(item.value)
      }
    })
    // console.log('formSubmit hostlist',hostlist,this.selectedHost);

    if (hostlist.length > 0) {

      this.logSearchService.searchSeggestionFilters['hosts'] = hostlist
      this.logSearchService.searchSeggestionFilters['platform'] = this.selectedPlatformValue
      this.logSearchService.searchSeggestionFilters['time_range'] = this.selectedTimeStructure
      this.logSearchService.searchSeggestionFilters['time_range_disp'] = this.selectedTimeRange
      this.logSearchService.searchSeggestionFilters['selectedHost'] = this.selectedHost

      // this.formCancel()


      let responseobj = {
        "platform": this.selectedPlatformValue,
        "platformfields": this.platformfields,
        "uniqueHostsList": hostlist,
        "selectedTimeStructure": this.selectedTimeStructure,
        "value": this.selectedHost,
        "time_range_disp": this.selectedTimeRange
      }
      this.assetsService._savedAssets.next(responseobj)
      this.overLayRef._cube.next({ ...responseobj, ...{ "platformfields": this.platformfields } })
      this.overLayRef.close()
    }
    else {
      this.sourceErrorState = true
      this.sourceErrorMsg = "Sourcename required"
    }
    // console.log("sumbit click====================formSubmit")

  }

  fetchPlatformFields(platform: string) {
    return this.assetsService.getSuggestionPlatformFields({ 'platform': platform }).toPromise()
  }

  fetchFieldsValue(platform: string, field_name: string, limit: number) {
    return this.assetsService.getSuggestionFieldValue({ 'platform': platform, 'field_name': field_name, 'limit': limit }).toPromise()
  }

  fetchHostTagsdata(platform) {
    return forkJoin([
      this.assetsService.getHostsList({ 'platform': platform }),
      this.assetsService.getHostsCategories({ 'platform': platform })
    ]).toPromise()
  }

  ClickedPlatform(platform: any) {
    this.suggestion_chips = []
    this.suggestionsourceSpinnerState = true
    this.suggestionfieldSpinnerState = true
    this.suggestionvalueSpinnerState = true

    this.sourceSearch.reset('')
    this.fieldsSearch.reset('')
    this.valueSearch.reset('')

    this.sourceSelectAll.setValue(false, { emitEvent: false })
    this.selectedPlatform = platform.disp
    this.selectedPlatformValue = platform.value
    this.fetchPlatformFields(platform.value)
      .then((platformfields: any) => {
        if (platformfields.platform_fields.length) {
          this.platformfields = platformfields.platform_fields;
          this.fieldsList = this.platformfields
          // console.log("fetchPlatformFields========platformfields===========",platformfields)
          this.selectedfield = this.fieldsList[0].disp
          this.selectedfield = this.fieldsList[0].disp == 'hash_id' ? this.fieldsList[1].disp : this.fieldsList[0].disp
          this.selectedfieldCount = this.fieldsList[0].disp == 'hash_id' ? this.fieldsList[1].count : this.fieldsList[0].count
          this.fetchLexiconValue(this.selectedPlatformValue, this.selectedfield, this.selectedfieldCount)
            .then((fieldsres: any) => {
              this.lexiconValue = fieldsres?.field_value
              this.fieldsValue = this.lexiconValue

              this.buildSuggestionChipsStru()
              this.fetchHostTagsdata(platform.value)
                .then(assets => {

                  this.assetsData = assets
                  for (let i = 0; i < this.assetsData[0]?.hosts?.length; i++) {
                    this.assetsData[0].hosts[i]["isSelected"] = (i == 0) ? true : false
                    this.assetsData[0].hosts[i]["index"] = i
                  }
                  this.selectedHost = JSON.parse(JSON.stringify(this.assetsData[0].hosts))
                  this.suggestionsourceSpinnerState = false
                  this.suggestionfieldSpinnerState = false
                  this.suggestionvalueSpinnerState = false

                })
                .catch((err) => {
                  //console.log("fetchHostTagsdata=======",err)
                })
            })
            .catch((err) => {
              //console.log("fetchLexiconValue=======",err)
            })
        } else {
          this.suggestionsourceSpinnerState = false
          this.suggestionfieldSpinnerState = false
          this.suggestionvalueSpinnerState = false
          this.selectedHost = []
          this.fieldsList = []
          this.fieldsValue = []
          this.platformfields = []
          this.lexiconValue = []
          this.assetsData[0].hosts = []

        }


        // this.loadnewplatform(platform);
      }).catch((err) => {
        //console.log(err)
      })

  }

  openOverlay(origin: any, component: any, componentInputs: any, dimensions: any) {
    this.overLayRef = this.cdkoverlayDialog.open({
      data: componentInputs,
      height: dimensions[0],
      width: dimensions[1],
    },
      origin, component)
    return this.overLayRef;
  }

  // openAdvancedFilter(origin: any, mode: number) {
  //   // console.log("openAdvancedFilter======", !this.isAction, this.alertvarService.advanced_filter_values, this.alertvarService.alertsheetmeta.filterOptions.advanceFilter)

  //   // if (!this.isAction) {
  //   const ref: cdkOverlayRef = this.openOverlay(origin, AdvanceFilterComponent,
  //     [
  //       { ...this.relative_time_options },
  //       { ...this.alertsheetmeta.filterOptions.advanceFilter }, mode]
  //     , mode ? ["45vh", "25vw"] : ["45vh", "55vw"]);
  //   // , ["45vh", "25vw"]);
  //   ref.$selectedValue.subscribe(response => {
  //     this.advanced_filter_values = response;
  //     this.advancedFilterChange.next(null);
  //   })
  //   // }
  // }

  buildSuggestionChipsStru() {
    this.suggestion_chips = []
    let limit = 0
    for (let val in this.fieldsValue) {
      if (!(this.fieldsValue[val] == '--NA--' || this.fieldsValue[val] == 'nil' || this.fieldsValue[val] == 'hash_id')) {
        this.suggestion_chips.push(this.fieldsValue[val])
        limit += 1
        if (limit > 2) {
          break
        }
      }
    }
    // console.log("buildSuggestionChipsStru",this.fieldsValue)
  }

  SelectedFields(fields: any, event: any) {
    this.suggestion_chips = []
    event.stopPropagation()
    this.selectedfield = fields.disp
//console.log('fields==',fields);

    if (fields.count > 0) {
      this.suggestionvalueSpinnerState = true
      this.fetchLexiconValue(this.selectedPlatformValue, fields.value, fields.count)
        .then((fieldsres: any) => {
          // console.log("SelectedFields",fieldsres)
          this.lexiconValue = fieldsres?.field_value
          this.fieldsValue = this.lexiconValue
          this.buildSuggestionChipsStru()
          this.suggestionvalueSpinnerState = false
        })
        .catch((err) => {
          //console.log("fetchLexiconValue===",err)
        })
    }


  }

  fetchLexiconValue(platform: string, field: string, limit: number) {
    limit = limit > 2000 ? 200 : limit
    return this.fetchFieldsValue(platform, field, limit)
  }

  buildDefaultRequest() {
    // console.log('this.logSearchService.searchSeggestionFilters',this.logSearchService.searchSeggestionFilters);

    // this.platformdata
    this.suggestion_chips = []

    // this.selectedPlatform = this.sharedService.platformMap[this.sharedService.metaData.commonData.platformOptions.default]
    // this.selectedPlatformValue = this.sharedService.metaData.commonData.platformOptions.default


    this.selectedPlatform = this.sharedService.platformMap[this.data[0]['platform']]
    this.selectedPlatformValue = this.data[0]['platform']
    this.selectedTimeStructure = this.data[1]
    this.selectedTimeRange = this.data[1]['disp']
    // this.selectedTimeRange = this.logSearchService.searchSeggestionFilters['time_range_disp']
    this.selectedHost = JSON.parse(JSON.stringify(this.data[0]['value']))
    this.logSearchService.suggestion_selected_platform = this.selectedPlatform
    // this.fetchPlatformFields(this.sharedService.metaData.commonData.platformOptions.default)
    this.fetchPlatformFields(this.data[0]['platform'])
      .then((platformfields: any) => {
        // console.log("buildDefaultRequest======",platformfields)
        this.platformfields = platformfields.platform_fields;
        this.fieldsList = this.platformfields
        this.selectedfield = this.fieldsList[0].disp
        this.fetchLexiconValue(this.selectedPlatformValue, this.fieldsList[0].value, this.fieldsList[0].count)
          .then((fieldsres: any) => {
            this.lexiconValue = fieldsres?.field_value
            this.fieldsValue = this.lexiconValue

            this.buildSuggestionChipsStru()
            // console.log('this.selectedHost ##',this.selectedHost);

            if (this.selectedHost.length == 0) {
              // this.fetchHostTagsdata(this.sharedService.metaData.commonData.platformOptions.default)
              this.fetchHostTagsdata(this.data[0]['platform'])

                .then(assets => {

                  this.assetsData = assets
                  for (let i = 0; i < this.assetsData[0]?.hosts?.length; i++) {

                    this.assetsData[0].hosts[i]["isSelected"] = (i == 0) ? true : false
                    this.assetsData[0].hosts[i]["index"] = i
                  }
                  this.selectedHost = JSON.parse(JSON.stringify(this.assetsData[0].hosts))

                  // console.log("this.assetsData========",this.assetsData)
                  // this.suggestionplatformSpinnerState = false
                  // this.suggestionsourceSpinnerState = false
                  // this.suggestionfieldSpinnerState = false
                  // this.suggestionvalueSpinnerState = false
                })

                .catch((err) => {
                  //console.log(err)
                })
            } else {
              this.assetsData = [{ "hosts": this.selectedHost, "no_of_hosts": this.selectedHost.length }]
            }
            // console.log('this.selectedHost', this.selectedHost);
            this.suggestionplatformSpinnerState = false
            this.suggestionsourceSpinnerState = false
            this.suggestionfieldSpinnerState = false
            this.suggestionvalueSpinnerState = false

          })




      })
      .catch((err) => {
        //console.log(err)
      })
  }

  selectedSource(index: number, hostinfo: any, event: any) {
    this.sourceErrorMsg = ''
    this.sourceErrorState = false
    event.stopPropagation()
    this.selectedHost[index]["isSelected"] = !this.selectedHost[index]["isSelected"]
    // console.log("hostinfo.index======",this.assetsData)
    // console.log("selectedHost======",this.selectedHost)
    this.assetsData[0].hosts[hostinfo.index]["isSelected"] = this.selectedHost[index]["isSelected"]

    let selecteAllStatus = false
    for (let i = 0; i < this.selectedHost.length; i++) {
      if (!this.selectedHost[i]["isSelected"]) {
        selecteAllStatus = true
        break
      }
    }
    // console.log("selectedSource----selecteAllStatus======",selecteAllStatus)
    if (selecteAllStatus) {
      this.sourceSelectAll.setValue(false, { emitEvent: false })
    }
    else {
      this.sourceSelectAll.setValue(true, { emitEvent: false })
    }
  }



  toggleActionSourceSelectall(status: boolean, searchval: string, mode: string) {
    // console.log("toggleActionSourceSelectall===========",status,searchval,mode)
    if (mode == 'valueChange') {
      for (let i = 0; i < this.selectedHost.length; i++) {
        this.selectedHost[i]["isSelected"] = status
        this.assetsData[0].hosts[this.selectedHost[i]["index"]]["isSelected"] = status
      }
    }
    else if (mode == 'search') {
      let selectallState = false
      for (let i = 0; i < this.selectedHost.length; i++) {
        if (!this.selectedHost[i]["isSelected"]) {
          selectallState = true
          break
        }
      }
      if (this.selectedHost.length == 0) {
        selectallState = true
      }
      // console.log("toggleActionSourceSelectall===========",status,searchval,mode,selectallState)
      if (selectallState) {
        this.sourceSelectAll.setValue(false, { emitEvent: false })
      }
      else {
        this.sourceSelectAll.setValue(true, { emitEvent: false })
      }
    }
  }

  toggleselectRelativeTime(relative_obj: any) {
    this.selectedTimeRange = relative_obj.disp
    this.selectedTimeStructure = relative_obj

  }
  opentimeOverlay(origin: any, component, componentInputs, dimensions) {
    this.internalOverlayRef = this.dropdown.open({
      data: componentInputs,
      height: dimensions[0],
      width: dimensions[1],
    }, origin, component);
    return this.internalOverlayRef;
  }
  openRealtiveTimePanelClick(origin) {
    this.opentimeOverlay(origin, TimePanelComponent, [this.selectedTimeStructure, document.getElementById('time'), 1], ["auto", "auto"]);
  }
  openCustomTimePanelClick(origin) {
    this.opentimeOverlay(origin, TimePanelComponent, [this.selectedTimeStructure, document.getElementById('CustomTime'), 2], ["auto", "auto"]);
  }

  ngOnDestroy(): void {
    this.$destroy.next(true)
  }
}
